/**
 * Label — Radix-backed semantic label so screen readers tie input + helper text
 * back to a single control. shadcn-style; tokens via Tailwind preset.
 *
 * The prototype's `<label>` markup is a plain element with no styling beyond
 * inherited typography. We mirror that here — small, ink-tone, medium weight —
 * and let `Field` handle layout.
 */
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "../lib/cn.js";

export type LabelProps = React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

export const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  function Label({ className, ...props }, ref) {
    return (
      <LabelPrimitive.Root
        ref={ref}
        className={cn(
          "text-sm leading-[18px] font-medium text-ink-2",
          "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
